import { useAppSelector } from 'store/hook';

const useCustomerInfo = () => {
  const customerCode = useAppSelector(
    (state) => state.persistedReducer.customer.code
  );

  const role = useAppSelector((state) => state.authReducer.role);

  const email = useAppSelector((state) => state.authReducer.email);

  const unitSystem = useAppSelector((state) => state.persistedReducer).customer
    .unitSystem;
  const timezone = useAppSelector((state) => state.persistedReducer).customer
    .timezone;

  const driverBehaviorThresholds = useAppSelector(
    (state) => state.authReducer.customer.driverBehavior
  );

  return {
    customerCode,
    unitSystem,
    email,
    role,
    customerTz: timezone,
    driverBehaviorThresholds,
  };
};

export default useCustomerInfo;
